import { BuyerOrderStatus } from '../../interfaces/garments/buyerOrder.interface';

/**
 * Mirror of backend `com.kervolt.oms.enums.BuyerOrderStatus#canTransitionTo` (garments-merchandising
 * T5/T10, PATCH `{id}/status`). `BuyerOrderList`/`BuyerOrderForm`/`BuyerOrderStatusDialog` use this —
 * never a free-form status list — so a dead/illegal transition is never offered:
 *
 * ```
 * DRAFT          -> CONFIRMED | CANCELLED
 * CONFIRMED      -> IN_PRODUCTION | CANCELLED
 * IN_PRODUCTION  -> SHIPPED | CANCELLED
 * SHIPPED        -> CLOSED
 * CLOSED | CANCELLED -> terminal
 * ```
 */
export const BUYER_ORDER_STATUS_TRANSITIONS: Record<BuyerOrderStatus, BuyerOrderStatus[]> = {
    DRAFT: ['CONFIRMED', 'CANCELLED'],
    CONFIRMED: ['IN_PRODUCTION', 'CANCELLED'],
    IN_PRODUCTION: ['SHIPPED', 'CANCELLED'],
    SHIPPED: ['CLOSED'],
    CLOSED: [],
    CANCELLED: [],
};

/** Every backend `BuyerOrderStatus` value. */
export const ALL_BUYER_ORDER_STATUSES: BuyerOrderStatus[] = [
    'DRAFT', 'CONFIRMED', 'IN_PRODUCTION', 'SHIPPED', 'CLOSED', 'CANCELLED',
];

/** Header and lines remain editable only while the order is DRAFT (H4/REV 2) — read-only for
 *  every other status, and the UI must say why (see `BuyerOrderLinesEditor`'s `readOnlyReason`). */
export const EDITABLE_BUYER_ORDER_STATUSES: BuyerOrderStatus[] = ['DRAFT'];

/** `BuyerOrderAmendDialog` (ship date + remarks only) is offered on these statuses only — hidden
 *  for DRAFT (still fully editable via the header/lines) and for SHIPPED/CLOSED/CANCELLED. */
export const AMENDABLE_BUYER_ORDER_STATUSES: BuyerOrderStatus[] = ['CONFIRMED', 'IN_PRODUCTION'];

export const legalBuyerOrderStatusTargets = (current: BuyerOrderStatus): BuyerOrderStatus[] =>
    BUYER_ORDER_STATUS_TRANSITIONS[current] ?? [];
